module.exports = __webpack_public_path__ + "img/close.fd4c2370.svg";